import React from "react";
import AddResource from './AddResource';
import ResourceList from './ResourceList';

export default function AddManageResource() {
  return (
    <>
        <AddResource/>
        <ResourceList/>
    </>
  );
}
